import { SafeImg } from '@/components/SafeImage';

import Constants from '@/constants';

import { VideoSearchResult } from '@/icons';

interface SearchResultCardImageProps {
  name: string;
  documentType: string;
  icon?: string;
}

const SearchResultCardImage: React.FC<SearchResultCardImageProps> = ({
  name,
  icon,
  documentType,
}) => {
  if (
    documentType.toLowerCase() ===
    Constants.EXPANDED_FILE_FORMAT_TYPES.BRIGHTCOVE
  ) {
    return <VideoSearchResult className="mr-2.5" />;
  }

  return (
    <SafeImg
      alt={name}
      src={
        Constants.PATHWAY_CDN_IMG.PROCEDURES +
        (icon === undefined || icon === 'placeholder' ? 'Chickfila' : icon) +
        '.svg'
      }
      fallback={`${Constants.PATHWAY_CDN_IMG.PROCEDURES}Chickfila.svg`}
      className="mr-2.5 flex w-10 min-w-10 rounded-none p-px"
    />
  );
};

export default SearchResultCardImage;
